import React, { useCallback, forwardRef } from 'react';
import Turnstile from 'react-turnstile';
import classNames from 'classnames';
import { Override } from 'types';
import useFormInput, { FormInputProps } from './useFormInput';
import './TurnstileField.scss';

type BaseProps = FormInputProps<string, HTMLInputElement> & {
  siteKey: string;
};

export type TurnstileProps = Override<React.ComponentPropsWithoutRef<'input'>, BaseProps>;

function TurnstileField(props: TurnstileProps, ref: React.Ref<HTMLInputElement>): JSX.Element {
  const { siteKey, onValueChange, className } = useFormInput(props);

  const handleChange = useCallback(
    (token: string) => {
      if (onValueChange) {
        onValueChange(token);
      }
    },
    [onValueChange],
  );

  return (
    <Turnstile
      sitekey={siteKey}
      className={classNames('FormTurnstile', className)}
      onVerify={(token) => handleChange(token)}
      onExpire={() => handleChange('')}
    />
  );
}

export default forwardRef(TurnstileField);
